import { MessageDescriptor } from 'react-intl';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_UPDATED_TEXT } from '../account-admin.text';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';

class ThirdPartyRegistrationFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_UPDATED_TEXT;
    }

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateThirdPartyRegistrationData({
            ...this.entity.getCommonAPIPayload(),
            thirdPartyRegistrationEnabled: this.entity.enabled,
        });
    }
}

export { ThirdPartyRegistrationFormVM };
